import React from "react";

const defaultParams = {};
export const ParamsContext = React.createContext(defaultParams);
